export default __webpack_public_path__ + "static/media/organization.6b3351c5.svg";